export const fmtAED = (n) =>
  new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED', minimumFractionDigits: 2 }).format(Number(n || 0));

export const fmtNum = (n) => new Intl.NumberFormat('en-AE').format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return '-';
  try { return new Date(s).toLocaleString('en-AE', { dateStyle: 'medium', timeStyle: 'short' }); }
  catch { return s; }
};

export const fmtDateShort = (s) => {
  if (!s) return '-';
  try { return new Date(s).toLocaleDateString('en-AE', { month: 'short', day: 'numeric' }); }
  catch { return s; }
};
